import { render, staticRenderFns } from "./PolicyFlexiblePath.vue?vue&type=template&id=7b3fe470&scoped=true&"
import script from "./PolicyFlexiblePath.vue?vue&type=script&lang=js&"
export * from "./PolicyFlexiblePath.vue?vue&type=script&lang=js&"
import style0 from "./PolicyFlexiblePath.vue?vue&type=style&index=0&id=7b3fe470&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3fe470",
  null
  
)

export default component.exports